import { Alert, Box, Grid, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "universal-cookie";
import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomButton from "../../components/Form/CustomButton";
import { ToastContext } from "../../context/toast-context";

import { CustomInput } from "../../components/Form/CustomInputField";
import { ToastContainer, toast } from "react-toastify";
import {
  registerUser,
  registerUserAndSignIn,
  signInUser,
} from "../../firebase/firebaseAuth";
import { useCart } from "../../context/cart-context";
import { AuthContext } from "../../context/auth-context";

const SignUpPage = () => {
  let navigate = useNavigate();
  const errRef = useRef();
  const [errMsg, setErrMsg] = useState("");

  const [userFirstName, setUserFirstName] = useState("");
  const [userLastName, setUserLastName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");

  const { setIsLoading } = useCart();

  const { isAuthenticated, userUID, loginUser } = React.useContext(AuthContext);

  const handleSubmit = async (e) => {
    // prevent the form from refreshing the whole page

    setErrMsg("");

    function validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    if (userFirstName === "") {
      setErrMsg("Please input first name");
    } else if (userLastName === "") {
      setErrMsg("Please input last name");
    } else if (validateEmail(userEmail) !== true) {
      setErrMsg("Please input a valid email address");
    } else if (userPassword === "") {
      setErrMsg("Please input a valid password");
    } else {
      setIsLoading(true);

      try {
        // let userData = { firstname, lastname, email, password, role };
        // const newDoc = await createDocument("user-list", userData);
        const email = userEmail;
        const password = userPassword;
        const additionalData = {
          firstname: userFirstName,
          lastname: userLastName,
          role: "user",
          address: "",
          city: "",
          state: "",
          country: "",
          zipcode: 0,
          shiPaddress: "",
          shiPcity: "",
          shiPstate: "",
          shiPcountry: "",
          shiPzipcode: 0,

          // Add other user details as needed
        };

        const user = await registerUserAndSignIn(
          email,
          password,
          additionalData
        );
        console.log("User registered and details stored in Firestore:", user);
        loginUser(user.email);
        userUID(user.uid);

        setIsLoading(false);
        toast(`Profile created with email: ${userEmail}`, {
          type: "success",
        });
        setTimeout(() => {
          navigate("/dashboard");
        }, 3000);
      } catch (error) {
        setIsLoading(false);
        setErrMsg("Error registering user");

        console.error("Error registering user:", error);
      }
    }
  };

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated]);

  return (
    <Fragment>
      <Grid container spacing={0} item={true}>
        <Grid xs={0} sm={6} md={7} item={true}>
          <div className="h-screen relative hidden md:flex items-center justify-center self-center">
            <img
              src="SBD/salon1.jpg"
              alt=""
              className="w-5/6 md:w-full md:py-0 py-48 object-cover h-full"
            />
            {/* <WomanIcon /> */}
          </div>
        </Grid>
        <Grid xs={12} sm={6} md={5} item={true}>
          <div className="bg-gray-50 h-full md:py-52 py-10">
            {/* Error Message */}

            {errMsg !== "" ? (
              <Box className="px-3 md:px-12">
                <Alert
                  severity="error"
                  onClose={() => {
                    setErrMsg("");
                  }}
                >
                  {errMsg}
                </Alert>
              </Box>
            ) : null}
            {/* Error Ends */}
            <Box as="div" className="w-3/4 mx-auto">
              <ToastContainer />

              <Typography
                variant="h3"
                fontWeight={400}
                fontSize={{ xs: "25px", sm: "30px", md: "30px" }}
                lineHeight={{ xs: "103%", sm: "105.5%" }}
                letterSpacing={"-0.01em"}
                color="primary"
                className=" text-center py-4 capitalize"
              >
                Create an account
              </Typography>

              <Grid container spacing={2} item={true} className="">
                <Grid xs={12} sm={6} md={6} item={true}>
                  <div className="mb-6 text-center">
                    <CustomInput
                      label="First Name"
                      type="text"
                      className="w-full"
                      onChange={(e) => {
                        setUserFirstName(e.target.value);
                        setErrMsg("");
                      }}
                      value={userFirstName}
                      required
                    />
                  </div>
                </Grid>
                <Grid xs={12} sm={6} md={6} item={true}>
                  <div className="mb-6 text-center">
                    <CustomInput
                      label="Last Name"
                      type="text"
                      className="w-full"
                      onChange={(e) => {
                        setUserLastName(e.target.value);
                        setErrMsg("");
                      }}
                      value={userLastName}
                      required
                    />
                  </div>
                </Grid>
                <Grid xs={12} sm={12} md={12} item={true}>
                  <div className="mb-6 text-center">
                    <CustomInput
                      label="Email"
                      type="email"
                      className="w-full"
                      onChange={(e) => {
                        setUserEmail(e.target.value);
                        setErrMsg("");
                      }}
                      value={userEmail}
                      required
                    />
                  </div>
                </Grid>

                <Grid xs={12} sm={12} md={12} item={true}>
                  <div className="mb-6 text-center">
                    <CustomInput
                      label="Password"
                      type="password"
                      className="w-full"
                      onChange={(e) => {
                        setUserPassword(e.target.value);
                        setErrMsg("");
                      }}
                      value={userPassword}
                      required
                    />
                  </div>
                </Grid>
              </Grid>
              <Box className="text-end mb-3">
                <Typography
                  variant="body"
                  fontSize={{ xs: "12px", sm: "12px", md: "12px" }}
                  lineHeight={{ xs: "185%", sm: "180%" }}
                  letterSpacing={"-0.02em"}
                  color={"primary"}
                >
                  Already have an account?
                  <Link className=" text-red-500 underline pl-1" to={"/login"}>
                    Sign in
                  </Link>
                </Typography>
              </Box>

              <div className="text-center mx-auto">
                <CustomButton
                  type="submit"
                  // form="add-member-form"
                  //   loading={true}
                  sx={{ width: "150px", height: "55px" }}
                  color="secondary"
                  className="text-sm !uppercase"
                  onClick={handleSubmit}
                  // to={"/checkout"}
                  // fullWidth
                >
                  Sign up
                </CustomButton>
              </div>
            </Box>
          </div>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default SignUpPage;
